export const TEAM_COLORS = {
  1: "#ff0000",
  2: "#ffb400",
  3: "#00c6ff",
  4: "#c3ff00",
  5: "#ff6600",
  6: "#ac40ff",
  7: "#00ffba",
  8: "#1c47ff",
  9: "#ff2dd5",
  10: "#48ff00",
};
